/* eslint-disable no-unused-vars */
/* eslint-disable global-require */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, Suspense, lazy, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Col, Row, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ProfilePic from '../../components/ProfilePic/profilePic';
import { TableContext } from '../../contexts/tableContext';
import { getCookies } from '../../hooks/useCookies';
import styles from './settings.module.scss';
import { ProfileEdits } from '../../redux/profileEditSlice';
import { SERVER_BASE_URL } from '../../redux/apiConstants';
import 'react-toastify/dist/ReactToastify.css';
import { Entry } from '../../redux/entrySlice';
import PhoneInputBox from '../../components/PhoneNumberBox/PhoneInput';

const EmailInput = lazy(() => import('../../components/EmailBox/EmailBox'));
const TextInput = lazy(() => import('../../components/TextField/TextField'));

const DEFAULT_PREFERENCES = {
  email: true,
  push: true,
  sms: false,
  eventUpdates: true,
  orderUpdates: true,
  systemAlerts: true,
};

const ProfileEdit = React.memo(() => {
  const navigate = useNavigate();
  const [submiting, setSubmitting] = useState(false);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { errormsgStyle } = useContext(TableContext);
  // eslint-disable-next-line no-unused-vars
  const [profileData, setProfileData] = useState(null);
  const token = `${getCookies('Token')}`;
  const userId = `${getCookies('USERID')}`;
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [notificationPrefs, setNotificationPrefs] = useState(DEFAULT_PREFERENCES);
  const [prefsLoading, setPrefsLoading] = useState(true);
  const [prefsUpdating, setPrefsUpdating] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
    setValue,
    control,
    trigger,
  } = useForm();
  useEffect(() => {
    window.scrollTo(0, 0);
    setDashboardHeader('Settings');
    const actionData = {};
    actionData.actionUrl = `user/${userId}`;
    actionData.actionMethod = 'get';
    dispatch(Entry(actionData)).then((resp) => {
      if (resp?.payload?.code === 200) {
        setProfileData(resp?.payload?.data?.user);
        reset(resp?.payload?.data?.user);
      } else if (resp?.payload?.code === 401 || resp?.payload?.code === 400) {
        setError(resp?.payload?.message);
      } else {
        setError('Something went wrong!');
      }
    });
  }, []);

  useEffect(() => {
    const fetchNotificationPreferences = async () => {
      try {
        setPrefsLoading(true);
        const headers = { Authorization: `Bearer ${token}` };
        const response = await axios.get(`${SERVER_BASE_URL}/notifications/preferences`, {
          headers,
        });
        if (response?.data?.code === 200 && response?.data?.data?.preferences) {
          setNotificationPrefs({ ...DEFAULT_PREFERENCES, ...response.data.data.preferences });
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || 'Failed to load notification preferences');
      } finally {
        setPrefsLoading(false);
      }
    };
    if (token) fetchNotificationPreferences();
  }, [token]);

  const isNotificationsOn =
    notificationPrefs.email ||
    notificationPrefs.push ||
    notificationPrefs.eventUpdates ||
    notificationPrefs.orderUpdates ||
    notificationPrefs.systemAlerts;

  const handleNotificationsToggle = async (enabled) => {
    const payload = enabled
      ? {
          email: true,
          push: true,
          sms: false,
          eventUpdates: true,
          orderUpdates: true,
          systemAlerts: true,
        }
      : {
          email: false,
          push: false,
          sms: false,
          eventUpdates: false,
          orderUpdates: false,
          systemAlerts: false,
        };
    setNotificationPrefs((prev) => ({ ...prev, ...payload }));
    try {
      setPrefsUpdating(true);
      const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
      const response = await axios.patch(`${SERVER_BASE_URL}/notifications/preferences`, payload, {
        headers,
      });
      if (response?.data?.code === 200) {
        setNotificationPrefs((prev) => ({ ...prev, ...response.data.data?.preferences }));
        toast.success(enabled ? 'Notifications turned on' : 'Notifications turned off');
      } else {
        setNotificationPrefs(notificationPrefs);
        toast.error(response?.data?.message || 'Update failed');
      }
    } catch (err) {
      setNotificationPrefs(notificationPrefs);
      toast.error(err?.response?.data?.message || 'Failed to update preference');
    } finally {
      setPrefsUpdating(false);
    }
  };

  const handlePhoneChange = (number) => {
    trigger('phone');
    setValue('phone', number);
  };

  const Password = useRef({});
  Password.current = watch('Password', '');
  const onSubmit = (data) => {
    setSubmitting(true);
    setError(null);
    const apiData = {
      email: data.email,
      name: data.name,
      businessName: data.businessName,
      phone: data.phone,
      token: data.token,
      userid: data.userid,
    };
    dispatch(ProfileEdits(apiData)).then((resp) => {
      setSubmitting(false);
      if (resp.payload.code === 200) {
        toast.success('Profile updated successfully.');
      } else {
        setError(resp.payload?.data?.message || resp.payload?.message || 'Update failed.');
      }
    });
  };
  return (
    <div className={`${styles[bodyStyle]} profile_conatiner`}>
      <div className={`${styles[formthemeStyle]} form_container`} id={styles.addform}>
        <Container fluid>
          <div className={styles.profilepicdiv}>
            <ProfilePic />
          </div>
          {profileData != null ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row className="mt-5">
                <Col md={6} sm={6}>
                  <Suspense
                    fallback={
                      <div className={styles.suspenseFallback}>
                        <p className={styles.loading}>Loading ..</p>
                      </div>
                    }
                  >
                    <TextInput
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      fieldName="name"
                      label="Name"
                      labelstyle={styles.formlabel}
                      register={register}
                      errors={errors}
                      placeHolder="Enter Your Name"
                      isRequired
                      maximLength={20}
                      minimLength={3}
                      mandatory
                    />
                  </Suspense>
                </Col>
                <Col md={6} sm={6}>
                  <Suspense
                    fallback={
                      <div className={styles.suspenseFallback}>
                        <p className={styles.loading}>Loading ..</p>
                      </div>
                    }
                  >
                    <TextInput
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      fieldName="businessName"
                      label="Business Name"
                      labelstyle={styles.formlabel}
                      register={register}
                      errors={errors}
                      placeHolder="Enter Your Business Name"
                      isRequired
                      maximLength={30}
                      minimLength={3}
                      mandatory
                    />
                  </Suspense>
                </Col>
              </Row>
              <Row>
                <Col md={6} sm={6}>
                  <Suspense
                    fallback={
                      <div className={styles.suspenseFallback}>
                        <p className={styles.loading}>Loading ..</p>
                      </div>
                    }
                  >
                    <EmailInput
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      label="Email"
                      labelstyle={styles.formlabel}
                      fieldName="email"
                      placeHolder="Enter Email Address"
                      register={register}
                      errors={errors}
                      isRequired
                      mandatory
                      readOnly
                    />
                  </Suspense>
                </Col>
                <Col md={6} sm={6}>
                  <Suspense
                    fallback={
                      <div className={styles.suspenseFallback}>
                        <p className={styles.loading}>Loading ..</p>
                      </div>
                    }
                  >
                    <PhoneInputBox
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      labelstyle={styles.formlabel}
                      label="Phone Number"
                      fieldName="phone"
                      placeHolder="Enter Phone Number"
                      defaultValue={profileData?.phone}
                      handleChange={handlePhoneChange}
                      control={control}
                      errors={errors}
                      mandatory
                    />
                  </Suspense>
                </Col>
              </Row>
              <input type="hidden" {...register('token')} value={token} />
              <input type="hidden" {...register('userid')} value={userId} />
              <span className="sub_btn updateBtn">
                <input
                  className={styles.savebtn}
                  type="submit"
                  disabled={submiting}
                  value={submiting ? 'Please wait...' : 'Save Changes'}
                />
              </span>
            </form>
          ) : (
            <div className={styles.profileLoadingContainer}>
              <p className={styles.loading}>Loading ..</p>
            </div>
          )}
          <br />
          {error && <h6 className={styles[errormsgStyle]}>{error}</h6>}

          {/* Manage Business Details */}
          <div className={styles.preferencesCard}>
            <h3 className={styles.preferencesTitle}>Business Details</h3>
            <p className={styles.preferenceLabel}>
              Manage your business name, contact information, address, and logo.
            </p>
            <button
              type="button"
              className={styles.manageBtn}
              aria-label="Manage business details"
              onClick={() => navigate('/edit-business-details')}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  navigate('/edit-business-details');
                }
              }}
            >
              Manage Business Details
            </button>
          </div>

          {/* Notification preferences */}
          <div className={styles.preferencesCard}>
            <h3 className={styles.preferencesTitle}>Notification preferences</h3>
            {prefsLoading ? (
              <div className={styles.preferencesLoading}>
                <p className={styles.loading}>Loading ..</p>
              </div>
            ) : (
              <div className={styles.preferenceRow}>
                <span className={styles.preferenceLabel}>Notifications</span>
                <button
                  type="button"
                  role="switch"
                  aria-checked={!!isNotificationsOn}
                  aria-label={`Notifications ${isNotificationsOn ? 'on' : 'off'}`}
                  className={`${styles.toggle} ${isNotificationsOn ? styles.toggleOn : ''}`}
                  disabled={prefsUpdating}
                  onClick={() => handleNotificationsToggle(!isNotificationsOn)}
                >
                  <span className={styles.toggleThumb} />
                </button>
              </div>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
});

export default ProfileEdit;
